import { useEffect } from 'react';
import type { ChatSendMessageType } from '@/types/chat';

type PendingMessage = {
  userPrompt: string;
  isStreaming: boolean;
};

type LocalDeferredSendState = {
  chatId: string;
  prompt: string;
  selectedFileIds?: string[];
  messageType?: ChatSendMessageType;
} | null;

export function useRestoreDeferredSendAfterNavigation({
  chatId,
  deferredSend,
  deferredSendFromStore,
  pendingMessage,
  setDeferredSend,
}: {
  chatId: string | undefined;
  deferredSend: LocalDeferredSendState;
  deferredSendFromStore: unknown;
  pendingMessage: PendingMessage | undefined;
  setDeferredSend: (next: LocalDeferredSendState) => void;
}) {
  useEffect(() => {
    // Restore deferred-send state after navigation while we were waiting.
    if (deferredSend) return;
    if (!pendingMessage || !pendingMessage.userPrompt) return;
    if (pendingMessage.isStreaming) return;
    if (!chatId) return;
    // If a persisted deferred send already exists in Redux, the background worker
    // (chatListener) is handling polling/send.
    if (deferredSendFromStore) return;
    setDeferredSend({ chatId, prompt: pendingMessage.userPrompt });
  }, [chatId, deferredSend, deferredSendFromStore, pendingMessage, setDeferredSend]);
}
